import { useTranslation } from 'react-i18next';
import { ListPageLayout } from '@/components/templates';
import { OrderListContainer } from '@/features/orders/containers/order-list-container';

export default function OrdersPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout title={t('orders.title')}>
      <OrderListContainer />
    </ListPageLayout>
  );
}
